const USER_TYPE_CONFIG = Object.freeze({
  USER_TYPE: {
    GUEST: "guest",
    NORMAL: "normal",
    SUBSCRIBED: "subscribed",
  },
  COMMON: {
    guest: {
      ui_components: {
        pageSizeChanger: false,
        graphCountSetting: false,
      },
      limit: {
        numPagesPerFetch: 1,
        numFilters: 5,
      },
    },
    normal: {
      ui_components: {
        pageSizeChanger: true,
        graphCountSetting: true,
      },
      limit: {
        numPagesPerFetch: 5,
        numFilters: Infinity,
      },
    },
    subscribed: {
      ui_components: {
        pageSizeChanger: true,
        graphCountSetting: true,
      },
      limit: {
        numPagesPerFetch: 5,
        numFilters: Infinity,
      },
    },
  },
  FACULTY: {
    guest: {
      ui_components: {
        honor: false,
        experience: false,
        education: false,
        award: false,
        pageSizeChanger: false,
      },
      limit: {
        list: 60,
        publications: 20,
        grants: 3,
        collaborators: 20,
        numPagesPerFetch: 1,
      },
    },
    normal: {
      ui_components: {
        honor: true,
        experience: true,
        education: true,
        award: true,
        pageSizeChanger: true,
      },
      limit: {
        list: -2,
        publications: -2,
        grants: -2,
        collaborators: -2,
        numPagesPerFetch: 5,
      },
    },
    subscribed: {
      ui_components: {
        honor: true,
        experience: true,
        education: true,
        award: true,
        pageSizeChanger: true,
      },
      limit: {
        list: -2,
        publications: -2,
        grants: -2,
        collaborators: -2,
        numPagesPerFetch: 5,
      },
    },
  },
  INSTITUTION: {
    guest: {
      ui_components: {
        pageSizeChanger: false,
        topKeywords: false,
      },
      limit: {
        numPagesPerFetch: 1,
      },
    },
    normal: {
      ui_components: {
        pageSizeChanger: true,
        topKeywords: true,
      },
      limit: {
        numPagesPerFetch: 5,
      },
    },
    subscribed: {
      ui_components: {
        pageSizeChanger: true,
        topKeywords: true,
      },
      limit: {
        numPagesPerFetch: 5,
      },
    },
  },
  UNIT: {
    guest: {
      ui_components: {
        listView: false,
        detailView: false,
      },
    },
    normal: {
      ui_components: {
        listView: true,
        detailView: true,
      },
    },
    subscribed: {
      ui_components: {
        listView: true,
        detailView: true,
      },
    },
  },
  VENUE: {
    guest: {
      ui_components: {
        pageSizeChanger: false,
        topAuthorsRanking: false,
        topInstitutionsRanking: false,
      },
      limit: {
        numPagesPerFetch: 1,
      },
    },
    normal: {
      ui_components: {
        pageSizeChanger: true,
        topAuthorsRanking: false,
        topInstitutionsRanking: false,
      },
      limit: {
        numPagesPerFetch: 5,
      },
    },
    subscribed: {
      ui_components: {
        pageSizeChanger: true,
        topAuthorsRanking: true,
        topInstitutionsRanking: true,
      },
      limit: {
        numPagesPerFetch: 5,
      },
    },
  },
  CONCEPT: {
    guest: {
      ui_components: {
        pageSizeChanger: false,
        topAuthorsRanking: false,
        topInstitutionsRanking: false,
      },
      limit: {
        numPagesPerFetch: 1,
      },
    },
    normal: {
      ui_components: {
        pageSizeChanger: true,
        topAuthorsRanking: false,
        topInstitutionsRanking: false,
      },
      limit: {
        numPagesPerFetch: 5,
      },
    },
    subscribed: {
      ui_components: {
        pageSizeChanger: true,
        topAuthorsRanking: true,
        topInstitutionsRanking: true,
      },
      limit: {
        numPagesPerFetch: 5,
      },
    },
  },
});

export default USER_TYPE_CONFIG;
